angular.module('services.newman.ExportService', [
  'global'
])

/**
 * The ExportService service stores methods used to access
 * system APIs.
 *
 * @class ExportService
 * @constructor
 * @module services.newman.ExportService
 */
.factory('ExportService', [
  function () {
    'use strict';

    var service = {

      queue: [],

      /**
       * Generates a CSV file formatted specifically for import into the Pearson
       * Spider LMS system from the provided list of cases.
       *
       * @param {Array<Object>} list - List of cases to export
       * @param {Object} data - Custom field data
       * @return {string} CSV data
       */
      exportForSpider: function exportForSpider(list, data) {
        var csvData = 'Asset ID,Ch#,Sect#,ContentType,Server,URL,Title,Ex# Spec,';
        csvData += 'Multimedia Library?,Section Level?,Page Number,Pool,Order,Width,Height\n';
        _.forEach(list, function (item) {
          csvData += ',,*,' + data.contentType
                  + ',' + data.server
                  + ',' + item.id
                  + ',' + item.label
                  + ',,Y,,,,,,\n';
        });

        return csvData;
      }


    };

    return service;
  }
]);
